import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CaretDownIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 12 8" },
        React.createElement("path", { d: "M0.646479 2.20712L5.6464 7.20704C5.84166 7.4023 6.15824 7.4023 6.35351 7.20704L11.3534 2.20712C11.5487 2.01186 11.5487 1.69528 11.3534 1.50001L10.6465 0.793053C10.4512 0.597793 10.1346 0.597793 9.93936 0.793053L5.99994 4.73247L2.06052 0.793053C1.86526 0.597793 1.54868 0.597793 1.35341 0.793053L0.646449 1.50001C0.451189 1.69527 0.451219 2.01185 0.646479 2.20712Z" })));
};

export { CaretDownIcon };
//# sourceMappingURL=CaretDownIcon.esm.js.map
